import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

/**
 * Props for Setup Passkey Failed event.
 */
export interface SetupPasskeyFailedProps extends EventProps {
    error?: string
}

/**
 * @event setup_passkey_failed
 */
export const SetupPasskeyFailedAnalytics = createAnalyticsStatic<SetupPasskeyFailedProps>(
    ANALYTICS_EVENTS.PASSKEY.SETUP_FAILED,
)

export default SetupPasskeyFailedAnalytics
